import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChUpdatePrescriptionMutation as useChUpdatePrescriptionMutationType } from "@/modules/patients/detail/prescription/ch/services/__generated__/useChUpdatePrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChUpdatePrescriptionMutation($input: Ch_updatePrescriptionInput!) {
    ch_updatePrescription(input: $input) {
      ch_Prescription {
        id
        language
        healthcareProviderId
        ...chPrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChUpdatePrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChUpdatePrescriptionMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChUpdatePrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChUpdatePrescriptionMutation }
